/** Factures et avoirs de la période (date de pièce). */
import { useFormatters } from "../../formats/useFormatters";
import { ListPager, usePagedRows } from "../../components/ListPager";
import { SortTh, sortRows, useTableSort } from "../../components/tableSort";
import "../clients/tables.css";
import type { ReportPiece } from "./types";

type PiecesTableProps = {
  rows: ReportPiece[];
  onOpen?: (row: ReportPiece) => void;
  onOpenClient?: (clientId: number) => void;
};

export function PiecesTable({ rows, onOpen, onOpenClient }: PiecesTableProps) {
  const { money, day } = useFormatters();
  const sort = useTableSort<"type" | "number" | "client" | "date" | "ht" | "ttc">();
  const shown = sort.key
    ? sortRows(rows, sort.dir, sort.key === "date" ? "date" : sort.key === "ht" || sort.key === "ttc" ? "num" : "text", (r) => {
        if (sort.key === "type") return r.doc_type === "credit_note" ? "Avoir" : "Facture";
        if (sort.key === "number") return r.number || "";
        if (sort.key === "client") return r.client_name || "";
        if (sort.key === "date") return r.issue_date || "";
        if (sort.key === "ht") return r.total_ht_cents;
        return r.total_ttc_cents;
      })
    : rows;
  const paged = usePagedRows(shown);
  if (rows.length === 0) {
    return <p className="fx-clients-empty">Aucune pièce validée sur cette période.</p>;
  }
  return (
    <div className="fx-clients-wrap">
      <table className="fx-clients-table">
        <thead>
          <tr>
            <SortTh label="Type" active={sort.key === "type"} dir={sort.dir} onSort={() => sort.onSort("type", "text")} />
            <SortTh label="N°" active={sort.key === "number"} dir={sort.dir} onSort={() => sort.onSort("number", "text")} />
            <SortTh label="Client" active={sort.key === "client"} dir={sort.dir} onSort={() => sort.onSort("client", "text")} />
            <SortTh label="Date" active={sort.key === "date"} dir={sort.dir} onSort={() => sort.onSort("date", "date")} />
            <SortTh className="is-num" label="HT" active={sort.key === "ht"} dir={sort.dir} onSort={() => sort.onSort("ht", "num")} />
            <SortTh className="is-num" label="TTC" active={sort.key === "ttc"} dir={sort.dir} onSort={() => sort.onSort("ttc", "num")} />
          </tr>
        </thead>
        <tbody>
          {paged.slice.map((r) => (
            <tr key={r.id}>
              <td>{r.doc_type === "credit_note" ? "Avoir" : "Facture"}</td>
              <td>
                {onOpen ? (
                  <button type="button" className="fx-clients-table__link" onClick={() => onOpen(r)}>
                    {r.number || "—"}
                  </button>
                ) : (
                  r.number || "—"
                )}
              </td>
              <td>
                {onOpenClient && r.client_id ? (
                  <button type="button" className="fx-clients-table__link" onClick={() => onOpenClient(r.client_id)}>
                    {r.client_name || "—"}
                  </button>
                ) : (
                  r.client_name || "—"
                )}
              </td>
              <td>{day(r.issue_date)}</td>
              <td className="is-num">{money(r.total_ht_cents)}</td>
              <td className="is-num">{money(r.total_ttc_cents)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <ListPager page={paged.page} pages={paged.pages} total={paged.total} from={paged.from} to={paged.to} setPage={paged.setPage} />
    </div>
  );
}
